import styled, { css } from 'styled-components'

export interface INoContentBoxProps {
  message?: string
  image?: JSX.Element | string
  title?: string
  actions?: JSX.Element
  maxWidth?: string
}

export const NoContentBox = ({ message, image, title, actions, maxWidth }: INoContentBoxProps) => {
  return (
    <Div data-testid="no-content-container" maxWidth={maxWidth}>
      {image}
      <div className="details">
        {title && (
          <p data-testid="title" className="title">
            {title}
          </p>
        )}
        {message && (
          <p data-testid="message" className="message">
            {message}
          </p>
        )}
      </div>
      {actions && <div className="actions">{actions}</div>}
    </Div>
  )
}

const Div = styled.div<{ maxWidth?: string }>`
  position: absolute !important;
  inset: 0 0 0 0;
  height: 100%;
  width: 100%;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.25em;
  position: relative;
  top: -1em;

  .details {
    ${({ maxWidth }) =>
      maxWidth &&
      css`
        max-width: ${maxWidth};
      `}
    white-space: pre-wrap;

    > .title {
      color: ${({ theme }) => theme.colors.primary.darker};
      ${({ theme }) => theme.typography.h4.normal};
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      margin-top: 1.25;
    }

    > .message {
      ${({ theme }) => theme.typography.m.normal};
      color: ${({ theme }) => theme.colors.grey.darker};
    }
  }
`
